import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from "vue2-google-maps";
//Using Cluster requires marker-clusterer-plus to be installed.
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import VueGeolocation from 'vue-browser-geolocation';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
//import 'node_modules/slick-carousel/slick/slick.css';

Vue.component("cluster", GmapCluster);
Vue.use(PerfectScrollbar);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);
Vue.use(VueGeolocation);
//Vue.use(geodist);

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDifxGSsDE4O6_LH4EInM6MHpWM_MeZG2o'
  },
  installComponents: false
});

new Vue({
  render: h => h(App),
}).$mount('#app')
